module.exports = __webpack_public_path__ + "static/applestore.715469bf.png";